import React from 'react'
import { Link } from 'react-router-dom'

function Blog() {
  return (
    <div>
    
    <div className="breadcrumb-row">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="d-flex justify-content-between align-items-center breadcrumb-item">
                            <div className="breadcrumb-title-heading">
                                <h1 className="title">Blog</h1>
                            </div>
                            <div className="breadcrumb-wrapper">
                                <span className="mr-1"><i className="ti ti-home"></i></span>
                                <Link title="Homepage" to="/">Home</Link>
                                <span className="ttm-bread-sep">&nbsp;/&nbsp;</span>
                                <span className="ttm-textcolor-skincolor">Blog</span>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>                    
        </div>
    {/* <!-- Section Start --> */}
    <section className="section-padding">
        <div className="container-fluid">
            <div className="section-header">
                <h3 className="title">Blog Grid</h3>
                <p className="text">Lorem ipsum dolor sit amet, consectetur.</p>
            </div>
            <div className="row justify-content-center">
                <article className="col-lg-4 col-md-6 post">
                    <div className="post_image">
                        <Link to="/blog-details">
                            <img src="/tm/react/toolways/assets/images/blog/blog-1.jpg" className="image-fit" alt="img"/>
                        </Link>
                        <Link to="/blog-details" className="post_date">
                            18 Oct
                        </Link>
                    </div>
                    <div className="post_caption">
                        <ul className="post_meta">
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-user"></i>
                                    Admin
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-comments"></i>
                                    8.6k
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-eye"></i>
                                    9.5k
                                </Link>
                            </li>
                        </ul>
                        <h2 className="post_title">
                            <Link to="/blog-details">All Type Power Tool And Kits Availble</Link>
                        </h2>
                    </div>
                </article>
                <article className="col-lg-4 col-md-6 post">
                    <div className="post_image">
                        <Link to="/blog-details">
                            <img src="/tm/react/toolways/assets/images/blog/blog-2.jpg" className="image-fit" alt="img"/>
                        </Link>
                        <Link to="/blog-details" className="post_date">
                            18 Oct
                        </Link>
                    </div>
                    <div className="post_caption">
                        <ul className="post_meta">
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-user"></i>
                                    Admin
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-comments"></i>
                                    8.6k
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-eye"></i>
                                    9.5k
                                </Link>
                            </li>
                        </ul>
                        <h2 className="post_title">
                            <Link to="/blog-details">All New Products and Expensive Machine</Link>
                        </h2>
                    </div>
                </article>
                <article className="col-lg-4 col-md-6 post">
                    <div className="post_image">
                        <Link to="/blog-details">
                            <img src="/tm/react/toolways/assets/images/blog/blog-3.jpg" className="image-fit" alt="img"/>
                        </Link>
                        <Link to="/blog-details" className="post_date">
                            18 Oct
                        </Link>
                    </div>
                    <div className="post_caption">
                        <ul className="post_meta">
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-user"></i>
                                    Admin
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-comments"></i>
                                    8.6k
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-eye"></i>
                                    9.5k
                                </Link>
                            </li>
                        </ul>
                        <h2 className="post_title">
                            <Link to="/blog-details">Powerful Motor For The Best Performance Recompound Miter Saw</Link>
                        </h2>
                        </div>
                </article>
                <article className="col-lg-4 col-md-6 post">
                    <div className="post_image">
                        <Link to="/blog-details">
                            <img src="/tm/react/toolways/assets/images/blog/blog-4.jpg" className="image-fit" alt="img"/>
                        </Link>
                        <Link to="/blog-details" className="post_date">
                            18 Oct
                        </Link>
                    </div>
                    <div className="post_caption">
                        <ul className="post_meta">
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-user"></i>
                                    Admin
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-comments"></i>
                                    8.6k
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-eye"></i>
                                    9.5k
                                </Link>
                            </li>
                        </ul>
                        <h2 className="post_title">
                            <Link to="/blog-details">Best Lower Prices On Hundreds Premium Quality Tool</Link>
                        </h2>
                        
                    </div>
                </article>
                <article className="col-lg-4 col-md-6 post">
                    <div className="post_image">
                        <Link to="/blog-details">
                            <img src="/tm/react/toolways/assets/images/blog/blog-5.jpg" className="image-fit" alt="img"/>
                        </Link>
                        <Link to="/blog-details" className="post_date">
                            18 Oct
                        </Link>
                    </div>
                    <div className="post_caption">
                        <ul className="post_meta">
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-user"></i>
                                    Admin
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-comments"></i>
                                    8.6k
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-eye"></i>
                                    9.5k
                                </Link>
                            </li>
                        </ul>
                        <h2 className="post_title">
                            <Link to="/blog-details">Why We Used One Of The Best Corded Drill Power Toolse</Link>
                        </h2>
                        
                    </div>
                </article>
                <article className="col-lg-4 col-md-6 post">
                    <div className="post_image">
                        <Link to="/blog-details">
                            <img src="/tm/react/toolways/assets/images/blog/blog-6.jpg" className="image-fit" alt="img"/>
                        </Link>
                        <Link to="/blog-details" className="post_date">
                            18 Oct
                        </Link>
                    </div>
                    <div className="post_caption">
                        <ul className="post_meta">
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-user"></i>
                                    Admin
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-comments"></i>
                                    8.6k
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-eye"></i>
                                    9.5k
                                </Link>
                            </li>
                        </ul>
                        <h2 className="post_title">
                            <Link to="/blog-details">The Most Advanced Quality Tools For Welding Work</Link>
                        </h2>
                        
                    </div>
                </article>
                <article className="col-lg-4 col-md-6 post">
                    <div className="post_image">
                        <Link to="/blog-details">
                            <img src="/tm/react/toolways/assets/images/blog/blog-7.jpg" className="image-fit" alt="img"/>
                        </Link>
                        <Link to="/blog-details" className="post_date">
                            18 Oct
                        </Link>
                    </div>
                    <div className="post_caption">
                        <ul className="post_meta">
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-user"></i>
                                    Admin
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-comments"></i>
                                    8.6k
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-eye"></i>
                                    9.5k
                                </Link>
                            </li>
                        </ul>
                        <h2 className="post_title">
                            <Link to="/blog-details">Do You Know How To Buy High Quality Products </Link>
                        </h2>
                        
                    </div>
                </article>
                <article className="col-lg-4 col-md-6 post">
                    <div className="post_image">
                        <Link to="/blog-details">
                            <img src="/tm/react/toolways/assets/images/blog/blog-8.jpg" className="image-fit" alt="img"/>
                        </Link>
                        <Link to="/blog-details" className="post_date">
                            18 Oct
                        </Link>
                    </div>
                    <div className="post_caption">
                        <ul className="post_meta">
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-user"></i>
                                    Admin
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-comments"></i>
                                    8.6k
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-eye"></i>
                                    9.5k
                                </Link>
                            </li>
                        </ul>
                        <h2 className="post_title">
                            <Link to="/blog-details">Why We Used Best Hand Tools For Used</Link>
                        </h2>
                        
                    </div>
                </article>
                <article className="col-lg-4 col-md-6 post">
                    <div className="post_image">
                        <Link to="/blog-details">
                            <img src="/tm/react/toolways/assets/images/blog/9.jpg" className="image-fit" alt="img"/>
                        </Link>
                        <Link to="/blog-details" className="post_date">
                            18 Oct
                        </Link>
                    </div>
                    <div className="post_caption">
                        <ul className="post_meta">
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-user"></i>
                                    Admin
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-comments"></i>
                                    8.6k
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog-details">
                                    <i className="fal fa-eye"></i>
                                    9.5k
                                </Link>
                            </li>
                        </ul>
                        <h2 className="post_title">
                            <Link to="/blog-details">Why You Need Any Popular Brand Tools</Link>
                        </h2>
                        
                    </div>
                </article>
            </div>
            <div className="row">
                <div className="col-12">
                    <nav>
                        <ul className="pagination">
                            <li className="page-item">
                                <Link className="page-link" to="#" aria-label="Previous">
                                    <span aria-hidden="true">&laquo;</span>
                                    <span className="sr-only">Previous</span>
                                </Link>
                            </li>
                            <li className="page-item active"><Link className="page-link" to="#">1</Link></li>
                            <li className="page-item"><Link className="page-link" to="#">2</Link></li>
                            <li className="page-item"><Link className="page-link" to="#">3</Link></li>
                            <li className="page-item">
                                <Link className="page-link" to="#" aria-label="Next">
                                    <span aria-hidden="true">&raquo;</span>
                                    <span className="sr-only">Next</span>
                                </Link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default Blog